module.exports = function () {
    const links = document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])'),
        header = document.querySelector(".header");

    for (const link of links) {
        link.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        let href = this.getAttribute("href");

        // Check in anchor is another page
        if ( href.includes('/#') ) {
            href = href.replace('/#', '#')
        }
        else {
            e.preventDefault();

            // Check is element on the page
            if ( document.querySelector(href) ) {
                let offsetTop = document.querySelector(href)?.getBoundingClientRect().top - window.scrollY;
                    offsetTop = header ? ( offsetTop - header.getBoundingClientRect().height - 50) : offsetTop;

                scroll({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        }
    }
    
    // Scroll to section ather load page with anchor
    if ( window.location.hash ) {
        if( window.location.hash === '#read' ) {
            const anchor = document.querySelector('#top');
            if ( anchor ) {
                let offsetTop = anchor?.getBoundingClientRect().top + window.scrollY;
                offsetTop = header ? ( offsetTop - header.getBoundingClientRect().height - 50) : offsetTop;

                window.scrollTo(0, offsetTop);
            }
        } else {
            // Check is hash get id 
            const anchor = document.querySelector(window.location.hash);

            if ( anchor ) {
                let offsetTop = anchor?.getBoundingClientRect().top + window.scrollY;
                offsetTop = header ? ( offsetTop - header.getBoundingClientRect().height - 50) : offsetTop;

                document.documentElement.scrollTop = 0;
                window.location.hash = "";
                setTimeout(() => {
                    scroll({
                        top: offsetTop,
                        behavior: "smooth"
                    });
                }, 500)
            }
        }   
    }
};